import { Link, useNavigate } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Logo, LogoMark } from "@/components/Logo";
import { useAuth } from "@/context/AuthContext";
import { abEvent } from "@/lib/ab";

// Header + footer shared by the public marketing pages (/pricing, /showcase).
export default function PublicShell({ children, active }) {
  const { user } = useAuth();
  const navigate = useNavigate();
  const go = () => { abEvent("cta"); navigate(user ? "/dashboard" : "/login"); };
  const link = (to, label, id) => <Link to={to} className={`transition-colors hover:text-foreground ${active === id ? "text-foreground" : ""}`} data-testid={`public-nav-${id}`}>{label}</Link>;
  return (
    <div className="min-h-screen bg-background grid-bg flex flex-col">
      <header className="sticky top-0 z-40 glass border-b border-border">
        <div className="max-w-7xl mx-auto px-6 h-16 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-2" data-testid="public-nav-home"><Logo iconSize={26} textClassName="text-xl" /></Link>
          <nav className="hidden md:flex items-center gap-8 text-sm text-muted-foreground">
            {link("/#features", "Features", "features")}{link("/showcase", "Showcase", "showcase")}{link("/pricing", "Pricing", "pricing")}
          </nav>
          <div className="flex items-center gap-2">
            {!user && <Link to="/login" className="text-sm text-muted-foreground hover:text-foreground px-3" data-testid="public-nav-login">Sign in</Link>}
            <Button onClick={go} className="bg-primary text-primary-foreground hover:bg-primary/90 font-semibold glow-primary" data-testid="public-nav-cta">{user ? "Open Studio" : "Start free"}</Button>
          </div>
        </div>
      </header>
      <main className="flex-1">{children}</main>
      <section className="max-w-4xl mx-auto px-6 py-16 text-center">
        <h2 className="font-display text-3xl font-extrabold">Build your game's sound.</h2>
        <p className="text-muted-foreground mt-3 mb-6">Get 20 free credits. No card required.</p>
        <Button onClick={go} size="lg" className="bg-primary text-primary-foreground hover:bg-primary/90 font-semibold glow-primary" data-testid="public-footer-cta">Start generating <ArrowRight size={18} className="ml-1.5" /></Button>
      </section>
      <footer className="border-t border-border">
        <div className="max-w-7xl mx-auto px-6 py-8 flex items-center justify-between text-sm text-muted-foreground">
          <div className="flex items-center gap-2"><LogoMark size={18} /> MusicFlow StudioAi · Insert.si.on</div>
          <div className="flex items-center gap-5 text-xs"><Link to="/pricing" className="hover:text-foreground">Pricing</Link><Link to="/showcase" className="hover:text-foreground">Showcase</Link><Link to="/terms" className="hover:text-foreground" data-testid="public-footer-terms">Terms</Link><Link to="/privacy" className="hover:text-foreground" data-testid="public-footer-privacy">Privacy</Link><span className="font-mono">© 2026</span></div>
        </div>
      </footer>
    </div>
  );
}
